import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core-react/tracking';

import type { CheckedEmailDomainResult } from '#src/app/shared/utils/email';

export function useMisspelledEmailDomainTracking(): (checkResult: CheckedEmailDomainResult) => void {
	const track = useTracking();

	return useCallback(
		({ initialDomain, suggestedDomain }: CheckedEmailDomainResult) => {
			void track('email_domain_typo', {
				typo_domain: initialDomain,
				suggest_domain: suggestedDomain,
				event: 'display_msg',
				context: 'petitions_show',
			});
		},
		[track],
	);
}
